

export const secretKey = "codehash";

//export const API = "http://192.168.0.50:8000";//ruta al hacer click en el logo sita
export const API = "https://sita.talleravellaneda.com.ar";//ruta al hacer click en el logo sita

//export const API_LOGIN = "http://192.168.0.55/loginAPI.php";
export const API_LOGIN = "https://api.talleravellaneda.com.ar/loginAPI.php";//SERVIDOR DE PRODUCCION


//export const API_AUDITORIAS = "http://localhost/API-Auditorias.php";
export const API_AUDITORIAS = "https://api.talleravellaneda.com.ar/API-Auditorias.php";//SERVIDOR DE PRODUCCION

//export const API_PROCEDIMIENTOS = "http://localhost/API-Procedimientos.php";
export const API_PROCEDIMIENTOS = "https://api.talleravellaneda.com.ar/API-Procedimientos.php";//SERVIDOR DE PRODUCCION